import DOMPurify from 'dompurify';

export const sanitizeHTML = (dirty: string): string => {
  return DOMPurify.sanitize(dirty || '', {
    ALLOWED_TAGS: [
      'p',
      'br',
      'ul',
      'ol',
      'li',
      'strong',
      'em',
      'b',
      'i',
      'a',
      'img',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'alt', 'src', 'title', 'class'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'style', 'xmlns'],
    FORBID_TAGS: [
      'script',
      'iframe',
      'object',
      'embed',
      'form',
      'input',
      'textarea',
    ],
    ALLOWED_URI_REGEXP: /^(https?|ftp|mailto|tel):/i,
    ADD_ATTR: ['target'],
    ADD_TAGS: [],
    CUSTOM_ELEMENT_HANDLING: {
      tagNameCheck: null,
      attributeNameCheck: null,
      allowCustomizedBuiltInElements: false,
    },
  });
};
